var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('table-component',{attrs:{"section":'userGroup',"detail-url":'userGroupDetail',"columns":_vm.columns,"show-status-actions":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }